import React from 'react';
import {FormattedMessage} from 'react-intl';
import classnames from 'classnames';
import {useListUnreadMessagesContext} from '../ListUnreadMessagesContext';
import ButtonAction from '../../../../common/components/ui/ButtonAction';
import ModalPopup from '../../../../common/components/ui/ModalPopup';
import ListUnreadMessages from '../ListUnreadMessages';
import bell from '../../../../common/assets/icons/bell.svg';
import styles from './ButtonUnreadMessages.module.scss';

interface ButtonUnreadMessagesProps {
  className?: string
}

const ButtonUnreadMessages = ({className}: ButtonUnreadMessagesProps) => {
  const {open, openPopup, closePopup, messages} = useListUnreadMessagesContext();

  return (messages.length > 0)
    ? (
      <div className={classnames(styles.buttonUnreadMessagesContainer, className)}>
        <ButtonAction
          label={
            <div className={styles.buttonUnreadMessagesLabel}>
              <img src={bell} alt="icon" className={styles.buttonUnreadMessagesIcon}/>
              {(messages.length > 1)
                ? (
                  <FormattedMessage
                    id={'dashboard-button-label-unreadMessages'}
                    defaultMessage={'New messages'}
                  />
                )
                : (
                  <FormattedMessage
                    id={'dashboard-button-label-unreadMessage'}
                    defaultMessage={'New message'}
                  />
                )}
            </div>
          }
          onClick={openPopup}
          customClassnames={{container: styles.buttonUnreadMessages}}
        />
        <ModalPopup
          isOpen={open}
          onRequestClose={closePopup}
        >
          <ListUnreadMessages/>
        </ModalPopup>
      </div>
    )
    : null;
};

export default ButtonUnreadMessages;
